import styled from "@emotion/styled";

export const LoaderContainer = styled.div`
    /* width: 10%; */
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
`;

export const CenterContainer = styled.div`
    position: absolute;    
    height:100%;
    max-width:200px;
    max-height: 250px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;